const setLanguage = (payload) => {
    return {
        type: "languageChange",
        payload
    }
};

export default setLanguage;